/**
 * Helpers puros del storage de comprobantes de ventas POS.
 * Separado del repo para poder testearlo sin arrastrar supabaseClient.
 */

export const SALE_ATTACHMENTS_BUCKET = 'sale-attachments';

export function saleAttachmentExtension(mimeType: string): string {
  if (mimeType.startsWith('image/png')) return 'png';
  if (mimeType.startsWith('image/jpeg') || mimeType.startsWith('image/jpg')) return 'jpg';
  if (mimeType === 'application/pdf') return 'pdf';
  return 'bin';
}

/** Path org-scoped: `${orgId}/${saleId}/${attachmentId}.${ext}` (RLS de storage). */
export function buildSaleAttachmentStoragePath(params: {
  orgId: string;
  saleId: string;
  attachmentId: string;
  mimeType: string;
}): string {
  const ext = saleAttachmentExtension(params.mimeType);
  return `${params.orgId}/${params.saleId}/${params.attachmentId}.${ext}`;
}
